// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".title--centered[data-v-5a307d8d]{padding:2rem 0 1rem;text-align:center}.skill-counter[data-v-5a307d8d]{font-weight:400;font-size:18px;line-height:100%;color:#939393}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
